/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_Li_Support_TextInputs */

const tr_servis_s4_li_support_text = /** @type {(inputs: Servis_S4_Li_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` standart talepler için 24 iş saati`)
};

const en_servis_s4_li_support_text = /** @type {(inputs: Servis_S4_Li_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` 24 business hours for standard requests`)
};

const de_servis_s4_li_support_text = /** @type {(inputs: Servis_S4_Li_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` 24 Arbeitsstunden für Standardanfragen`)
};

const ru_servis_s4_li_support_text = /** @type {(inputs: Servis_S4_Li_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` 24 рабочих часа для стандартных запросов`)
};

/**
* | output |
* | --- |
* | "24 business hours for standard requests" |
*
* @param {Servis_S4_Li_Support_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_li_support_text = /** @type {((inputs?: Servis_S4_Li_Support_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_Li_Support_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_li_support_text(inputs)
	if (locale === "de") return de_servis_s4_li_support_text(inputs)
	if (locale === "ru") return ru_servis_s4_li_support_text(inputs)
	return tr_servis_s4_li_support_text(inputs)
});